import { InterestRate, SupportedCurrencies, withStyles, Tooltip, formatPercent, formattedCurrency } from 'vopay';
import styles from './InterestAccountBanner.module.scss';
import { BodyText } from 'UI';
import AnnualRatesPopover from '../../AccountUI/AnnualRatesPopover/AnnualRatesPopover';
import { AccountType } from '../../AccountSummaryPage';

const cn = withStyles(styles);

type InterestDisplayProps = {
  currency: SupportedCurrencies;
  amount: number;
  rate: number;
  balance: number;
  interestRates: InterestRate[];
  accountType: AccountType;
};

export default function InterestDisplay({
  currency,
  amount,
  rate,
  balance,
  interestRates,
  accountType,
}: InterestDisplayProps) {
  return (
    <>
      <BodyText weight="em">
        {currency} {formattedCurrency(amount.toString())}
      </BodyText>

      <div className={cn('interestRate', 'lightText')}>
        <span>{formatPercent(rate)}</span>

        <Tooltip
          width="100%"
          information={
            <AnnualRatesPopover accountType={accountType} balance={Number(balance)} interestRates={interestRates} />
          }
          position="bottomLeft"
        />
      </div>
    </>
  );
}
